import React from "react";
import ListCalendar from "./ListCalendar";
import WaitingList from "./WaitingList";
import { Macros } from "../models/Macros";
import { useAppContext } from "../contexts/AppContext";
import { TListCalendarWrapperProps } from "../types/components/ListCalendarWrapper";

type TWaitingListCalendarProps = {
    id: number;
    onInfoOpen: (entryIds: number[], showPanel?: boolean) => void;
} & TListCalendarWrapperProps;

const getRefreshEvents = () => [
    Macros.Event.SELECT_RESERVATION,
    Macros.Event.RESERVATION_MADE_OR_MODIFIED,
];

const WaitingListCalendar = (props: TWaitingListCalendarProps) => {
    const appContext = useAppContext();

    const onSelection = (selection) => {
        appContext.fireEvent(`waitingList${props.id}`, Macros.Event.SELECT_RESERVATION, selection);
        appContext.focusFirstCalendar();
        props.onInfoOpen([selection.id], false);
    };

    return (
        <ListCalendar
            {...props}
            type={"waitingList"}
            refreshEvents={getRefreshEvents()}
            onSelection={onSelection}
        >
            <WaitingList />
        </ListCalendar>
    );
};

export default WaitingListCalendar;
